import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {axiosInstance} from '../services/Api';

// Async thunks (unchanged from your code)
export const fetchSales = createAsyncThunk(
  "sales/fetchSales",
  async (filters, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("/sales/filtredSales",filters);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data.message || "An error occurred");
    }
  }
);
export const fetchSpecificSales = createAsyncThunk(
  "sales/fetchSpecificSales",
  async (filters, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("/sales/filtredSales",filters);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data.message || "An error occurred");
    }
  }
);
export const fetchRelatedOrders = createAsyncThunk(
  "sales/fetchrelatedOrders",
  async (filters, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("/sales/relatedOrders",filters);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data.message || "An error occurred");
    }
  }
);


export const createSale = createAsyncThunk(
  "sales/createSale",
  async (saleData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("/sales", saleData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data.message || "An error occurred");
    }
  }
);
export const createOrder = createAsyncThunk(
  "sales/createOrder",
  async (saleData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("/sales", saleData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data.message || "An error occurred");
    }
  }
);

export const updateSale = createAsyncThunk(
  "sales/updateSale",
  async (saleData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("/sales", saleData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data.message || "An error occurred");
    }
  }
);


export const deleteSale = createAsyncThunk(
  "sales/deleteSale",
  async (saleData, { rejectWithValue }) => {
    try {
      // Replace _id with id
      const requestData = {
        ...saleData,
        id: saleData._id,
      };
      delete requestData._id; // Optionally, remove _id if not needed

      const response = await axiosInstance.post("/sales/delete", requestData);
      return { message: response.data.message, saleId: requestData.id };
    } catch (error) {
      return rejectWithValue(error.response?.data.message || "An error occurred");
    }
  }
);
export const fetchPendingSalesCount = createAsyncThunk(
  "sales/PendingCommandeCount",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/sales/PendingCommandeCount");
      return response.data.count;
    } catch (error) {
      return rejectWithValue(error.response?.data.message || "An error occurred");
    }
  }
);
export const generateDocumentNumber = createAsyncThunk(
  "sales/generate-document-number",
  async (typeId, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/sales/generate-document-number?typeId=${typeId}`);
      return response.data.numero;
    } catch (error) {
      return rejectWithValue(error.response?.data.message || "An error occurred");
    }
  }
);





// Sales slice
const salesSlice = createSlice({
  name: "sales",
  initialState: {
    sales: [],
    relatedOrders:[],
    sale: null,
    loading: false,
    error: null,
    message: null,
    selectedSale: null, // Add selectedSale property
    pagination: {},
    relatedOrdersPagination: {},
    PendingSalesCount:0,
    generatedNumero: null,
  },
  reducers: {
    clearAlerts: (state) => {
      state.message = null;
    },
    clearSalesData: (state) => {
      state.sales = [];
    },
    setSelectedSale: (state, action) => {
      state.selectedSale = action.payload; // Set the selected sale
    },
    clearSelectedSale: (state) => {
      state.selectedSale = null; // Clear the selected sale
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSales.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSales.fulfilled, (state, action) => {
        state.loading = false;
        state.sales = action.payload.sales;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchSales.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchRelatedOrders.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRelatedOrders.fulfilled, (state, action) => {
        state.loading = false;
        state.relatedOrders = action.payload.sales;
        state.relatedOrdersPagination = action.payload.pagination;
      })
      .addCase(fetchRelatedOrders.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchSpecificSales.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSpecificSales.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedSale=action.payload.sales[0]  // Set the selected sale
      })
      .addCase(fetchSpecificSales.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createSale.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createSale.fulfilled, (state, action) => {
        state.loading = false;
        state.sales.push(action.payload);
        state.selectedSale=action.payload
        state.message = "Document cree avec succes";
      
      })
      .addCase(createSale.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteSale.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteSale.fulfilled, (state, action) => {
        state.loading = false;
        state.sales = state.sales.filter((sale) => sale._id !== action.payload.saleId);
        state.message = "Document suprime avec succes";
      })
      .addCase(deleteSale.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateSale.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateSale.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.sales.findIndex((sale) => sale._id === action.payload._id);
        if (index !== -1) {
          state.sales[index] = action.payload;
          state.selectedSale=action.payload
          state.message = "Document modifie avec succes";
        }
      })
      .addCase(updateSale.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createOrder.fulfilled, (state, action) => {
        state.loading = false;
        state.message = "Document cree avec succes";
      
      })
      .addCase(fetchPendingSalesCount.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPendingSalesCount.fulfilled, (state, action) => {
        state.loading = false;
        state.PendingSalesCount = action.payload;
      })
      .addCase(fetchPendingSalesCount.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(generateDocumentNumber.fulfilled, (state, action) => {
        state.generatedNumero = action.payload;
      })
      .addCase(generateDocumentNumber.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

// Export actions
export const { clearAlerts, setSelectedSale, clearSelectedSale, clearSalesData} = salesSlice.actions;

// Export the reducer
export default salesSlice.reducer;
